// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eoZx","left":"styles_left__-G2yq"};